import React, { useState, useEffect } from 'react';

const YoutubeMediaPopup = ({ onClose, onSave, media }) => {
    const [name, setName] = useState('');
    const [url, setUrl] = useState('');
    const [duration, setDuration] = useState(10);
    const [autoplay, setAutoplay] = useState(true);
    const [fullscreen, setFullscreen] = useState(false);
    const [mediaId, setMediaId] = useState(null);

    useEffect(() => {
        if (media) {
            setName(media.name || '');
            setUrl(media.url || '');
            setDuration(media.duration || 10);
            setAutoplay(media.autoplay ?? true);
            setFullscreen(media.fullscreen ?? false);
            setMediaId(media.id || null);
        }
    }, [media]);

    const handleSave = () => {
        if (!url) {
            alert('YouTube URL is required.');
            return;
        }

        onSave(name, url, duration, autoplay, fullscreen, mediaId);
    };

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <h2>{media ? 'Edit YouTube' : 'Add YouTube'}</h2>

                <div className="form-group">
                    <label>Name:</label>
                    <input type="text" className="form-control input-style" value={name} onChange={(e) => setName(e.target.value)} />
                </div>

                <div className="form-group">
                    <label>YouTube URL:</label>
                    <input type="text" className="form-control input-style" value={url} onChange={(e) => setUrl(e.target.value)} />
                </div>

                <div className="form-group">
                    <label>Duration (sec):</label>
                    <input type="number" className="form-control input-style" value={duration} onChange={(e) => setDuration(parseInt(e.target.value))} />
                </div>

                <div className="form-group">
                    <label>Autoplay:</label>
                    <input type="checkbox" checked={autoplay} onChange={(e) => setAutoplay(e.target.checked)} />
                </div>

                <div className="form-group">
                    <label>Fullscreen:</label>
                    <input type="checkbox" checked={fullscreen} onChange={(e) => setFullscreen(e.target.checked)} />
                </div>

                <div className="form-buttons mt-3">
                    <button className="btn btn-success" onClick={handleSave}>Save</button> &nbsp;
                    <button className="btn btn-primary" onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default YoutubeMediaPopup;
